import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';
import { footerData } from '../data/mockData';

export const Footer = () => {
  const socialIcons = {
    Linkedin,
    Twitter,
    Instagram,
    Facebook
  };

  return (
    <footer className="bg-[rgb(26,28,30)] border-t border-[rgba(255,255,255,0.1)] mt-32">
      <div className="container mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <div className="text-3xl font-bold transition-transform duration-300 hover:scale-105">
                <span className="text-[rgb(0,250,99)]">Onvyn</span>
              </div>
            </Link>
            <p className="text-[rgb(161,161,170)] text-sm leading-relaxed mb-6">
              {footerData.description}
            </p>
            <div className="flex space-x-3">
              {footerData.social.map((social) => {
                const Icon = socialIcons[social.icon];
                return (
                  <a
                    key={social.platform}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-11 h-11 rounded-xl bg-[rgb(38,40,42)] flex items-center justify-center text-[rgb(161,161,170)] hover:bg-[rgb(0,250,99)] hover:text-[rgb(17,17,19)] transition-all duration-300 hover:-translate-y-1"
                    aria-label={social.platform}
                  >
                    <Icon size={18} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Company</h3>
            <ul className="space-y-3">
              {footerData.links.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-[rgb(161,161,170)] hover:text-[rgb(0,250,99)] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Services</h3>
            <ul className="space-y-3">
              {footerData.links.services.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-[rgb(161,161,170)] hover:text-[rgb(0,250,99)] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Get in Touch</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-[rgb(0,250,99)] mt-0.5 flex-shrink-0" />
                <a
                  href={`mailto:${footerData.contact.email}`}
                  className="text-[rgb(161,161,170)] hover:text-[rgb(0,250,99)] transition-colors text-sm"
                >
                  {footerData.contact.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-[rgb(0,250,99)] mt-0.5 flex-shrink-0" />
                <a
                  href={`tel:${footerData.contact.phone}`}
                  className="text-[rgb(161,161,170)] hover:text-[rgb(0,250,99)] transition-colors text-sm"
                >
                  {footerData.contact.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[rgb(0,250,99)] mt-0.5 flex-shrink-0" />
                <span className="text-[rgb(161,161,170)] text-sm">
                  {footerData.contact.address}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[rgba(255,255,255,0.1)]">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[rgb(161,161,170)] text-sm">
              © {new Date().getFullYear()} {footerData.companyName}. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link
                to="/privacy"
                className="text-[rgb(161,161,170)] hover:text-[rgb(0,250,99)] transition-colors text-sm"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-[rgb(161,161,170)] hover:text-[rgb(0,250,99)] transition-colors text-sm"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
